// src/components/FloatingRegisterButton.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GraduationCap, ArrowRight } from 'lucide-react';
import '../styles/FloatingRegisterButton.scss';

const FloatingRegisterButton = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleRegisterClick = () => {
    navigate('/admission-enquiry');
  };

  return (
    <div className="floating-register-btn">
      <button 
        onClick={handleRegisterClick}
        className="register-button"
        aria-label="Register Now for Admission"
      >
        <div className="button-glow"></div>
        <div className="button-content">
          <GraduationCap size={18} className="btn-icon" />
          <span>{t('apply_for_admission')}</span>
          <ArrowRight size={14} className="btn-arrow" />
        </div>
      </button>
    </div>
  );
};

export default FloatingRegisterButton;
